module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAzCAYAAADYfStTAAAABGdBTUEAALGPC/xhBQAAAP5JREFUaAXt2qEOwjAQBuD/Rg1zCLAIFCM8AAmOR+ENsDwLT4Aj4TVIUHNYEIgZEsjSHpPVTdZ0zT/VLLne3XeqTeWFaufgTsjgU+jVAK7sFvMM+oEA0yKHRvwe2JCvkeKaE0pxKn5NpsCodrBH/+dw11IPt3ZWTgEKUIACFKAABSiQnYA8saoUdp9DZwK5G4FdOOghh4YAPfPEmvokOSFOKLKAcSgagbtFzttLOoE+etmYm1KAAhSgAAUoQAEKUCBEQBqsJz+0y5Dg1GK60+rbfNFuLfSSWnEh9XQvSXhJEgIXNYaXJFG5A5JxQgFoUUNEsRk/0cyiZu0tWfn5A3m6K3Hm+h16AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = 486
// module chunks = 1